const tabBar = [
  {
    "pagePath": "/layout/home",
    "text": "首页",
    "iconPath": require("@/assets/images/tabBar/home.png"),
    "selectedIconPath": require("@/assets/images/tabBar/home_active.png")
  },
  {
    "pagePath": "/layout/dialogue",
    "text": "对话",
    "iconPath": require("@/assets/images/tabBar/dialogue.png"),
    "selectedIconPath": require("@/assets/images/tabBar/dialogue_active.png")
  },
  {
    "pagePath": "/layout/my",
    "text": "我的",
    "iconPath": require("@/assets/images/tabBar/my.png"),
    "selectedIconPath": require("@/assets/images/tabBar/my_active.png")
  },
]
export default {
  tabBar
}